import $ from 'jquery';
import '../Components/_Anchor.js';
import '../Components/_Header.js';
import '../Components/_Slider';
import '../Components/_Table.js';
import '../Components/_Tooltip.js';
import '../Components/_Modal.js';
import '../Components/_Readmore.js';
import '../Components/_Navi.js';
import '../Components/_Side.js';

$('.js-star').on('click', function (e) {
	e.preventDefault();
	$(this).toggleClass('is-active');
});

if (!$('.c-detail__action .c-box4').length) {
	$('.c-detail__action').addClass('no-box4');
}

let pagetop = $('.js-gotop');
$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
    pagetop.addClass('is-show');
  } else {
    pagetop.removeClass('is-show');
  }

  let w_stop = $('.c-footer').offset().top - $(window).innerHeight();
  if ($(this).scrollTop() > w_stop) {
    pagetop.addClass('is-absolute');
  } else {
    pagetop.removeClass('is-absolute');
  }
});

pagetop.click(function () {
  $('body, html').animate({ scrollTop: 0 }, 500);
});